var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import SecondaryNavLayout from "../../../Layout/SecondaryNavLayout";
import SecondaryNavButton, { SecondaryNavLink, } from "../../../UI/SecondaryNav/SecondaryNavButton";
import { getServiceOfferingsAdminCreatePath, getServiceOfferingsAdminShowPath, } from "./AdminServiceOfferingRoutes";
import usePagedSortedTable, { TotalPageMappers, } from "../../../Hooks/usePagedSortedTable";
import DateService from "../../../../Services/Shared/Date.service";
import { InlineFormFormat } from "../../../UI/FormFormat/FormFormat";
import ServiceOfferingService from "../../../../Services/ServiceOffering.service";
import BooleanDisplay from "../../../UI/BooleanDisplay/BooleanDisplay";
import ContentLayout from "../../../Layout/ContentLayout";
import useService from "../../../Hooks/useService";
import useCheckboxes from "../../../Hooks/useCheckboxes";
import SelectField from "../../../Form/SelectField";
const PAGE_SIZE = 100;
const tableSearchFormStateToSearchArgs = (formState) => {
    var _a;
    let active;
    switch ((_a = formState.active) === null || _a === void 0 ? void 0 : _a.value) {
        case "active":
            active = true;
            break;
        case "inactive":
            active = false;
            break;
        default:
            active = undefined;
            break;
    }
    return {
        active,
    };
};
const ServiceOfferingList = () => {
    var _a, _b;
    const [searchArgs, setSearchArgs] = React.useState({
        active: undefined,
    });
    const { getCheckbox, checkedItems, unCheckEverything } = useCheckboxes({
        externallyCheckedItems: [],
        equalsFunc: (a, b) => a.id === b.id,
    });
    const { table, dataState, refresh } = usePagedSortedTable({
        searchArgs,
        hover: true,
        striped: true,
        noDataComponent: "No Service Offerings found",
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        getData: (sort, pageNumber, sArgs) => {
            return ServiceOfferingService.search(Object.assign({}, sArgs), {
                max: PAGE_SIZE,
                offset: pageNumber * PAGE_SIZE,
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: (sort === null || sort === void 0 ? void 0 : sort.order) === "asc" ? "ascnullsfirst" : "descnullslast",
            });
        },
        addCheckboxes: {
            useCheckboxesMakeCheckbox: getCheckbox,
            getCheckedItem: (data, index) => data.data[index],
        },
        columns: [
            { title: "Name", sortId: "SERVICE_OFFERING_NAME" },
            { title: "Active", sortId: "SERVICE_OFFERING_ACTIVE" },
            { title: "Key Engagement", sortId: "SERVICE_OFFERING_KEY_ENGAGEMENT" },
            { title: "Meeting Length", sortId: "SERVICE_OFFERING_MEETING_LENGTH" },
            { title: "Modified By", sortId: "SERVICE_OFFERING_MODIFIED_BY" },
            { title: "Modified Date", sortId: "SERVICE_OFFERING_MODIFIED_DATE" },
        ],
        rows: ({ data }) => data.map((serviceOffering) => [
            _jsx(Link, { to: getServiceOfferingsAdminShowPath(serviceOffering.id), children: serviceOffering.name }, serviceOffering.id),
            _jsx(BooleanDisplay, { val: serviceOffering.active }, "active"),
            _jsx(BooleanDisplay, { val: serviceOffering.keyEngagement }, "key engagement"),
            serviceOffering.meetingLength,
            serviceOffering.modifiedBy.fullName,
            DateService.displayWithTime(serviceOffering.modifiedDate),
        ]),
    });
    const [bulkToggleActivationState, bulkToggleActivation] = useService(ServiceOfferingService.bulkToggleActivation);
    return (_jsxs(_Fragment, { children: [_jsx(SecondaryNavLayout, { dontAddSpacer: true, nav: _jsxs(_Fragment, { children: [_jsx(SecondaryNavLink, { icon: "plus", title: "Create a new service offering", label: "New", to: getServiceOfferingsAdminCreatePath() }, "new"), _jsx(SecondaryNavButton, { icon: "check", label: "Activate", title: "Activate selected service offerings", confirmMessage: `This will active the current ${checkedItems.length} selected service ${checkedItems.length > 1 ? `offerings` : `offering`}. Are you sure?`, onClick: () => bulkToggleActivation({
                                ids: checkedItems.map((sdl) => sdl.id),
                                active: true,
                            }).then(() => {
                                refresh();
                                unCheckEverything();
                            }), disabled: !checkedItems.length || bulkToggleActivationState.isLoading }), _jsx(SecondaryNavButton, { icon: "ban", label: "Deactivate", title: "Deactivate service offerings", confirmMessage: `This will deactivate the current ${checkedItems.length} selected service ${checkedItems.length > 1 ? `offerings` : `offering`}. Are you sure?`, onClick: () => bulkToggleActivation({
                                ids: checkedItems.map((sdl) => sdl.id),
                                active: false,
                            }).then(() => {
                                refresh();
                                unCheckEverything();
                            }), disabled: !checkedItems.length || bulkToggleActivationState.isLoading })] }) }), _jsxs(ContentLayout, { whiteBackground: true, paddingTop: true, paddingBottom: true, className: "fullMinHeightMinusSecondaryNav", children: [_jsxs("h1", { className: "mb-3", children: ["Service Offerings", " ", ((_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total) ? `(${(_b = dataState.data) === null || _b === void 0 ? void 0 : _b.total})` : ""] }), _jsx("div", { className: "mb-3", children: _jsx(InlineFormFormat, { saveButtonContents: "Search", handleSubmit: (formState) => __awaiter(void 0, void 0, void 0, function* () {
                                setSearchArgs(tableSearchFormStateToSearchArgs(formState));
                            }), children: _jsx(SelectField, { label: "Status", name: "active", options: [
                                    {
                                        label: "Active",
                                        value: "active",
                                    },
                                    {
                                        label: "Inactive",
                                        value: "inactive",
                                    },
                                ] }) }) }), _jsx("div", { className: "py-2", children: table })] })] }));
};
export default ServiceOfferingList;
